import React from 'react';
import queryString from 'query-string';

require('../../css/components/AssetSlat.scss');

'use strict';

export default class AssetLink extends React.Component {

    render() {
        var asset = this.props.asset;

        var assignment = this.props.assignment;

        var urlHash = this.props.urlHash || "";

        if (assignment) {
            urlHash = queryString.parse(urlHash);

            urlHash["assignmentId"] = assignment.id;

            if (!assignment.displayAsComplete && assignment.progress > 0 && assignment.progress < 1.0)
                urlHash["bookmark"] = Math.round(assignment.progress * 100) / 100;

            urlHash = queryString.stringify(urlHash);
        }

        var url = (asset ? asset.url : this.props.url) + (urlHash.length ? ("#" + urlHash) : "");

        return (
            <a className={this.props.className} href={url}>{this.props.title || asset.asset.title}</a>
        );
    }
}